/* istanbul ignore file */
import React from 'react';

import LoginRegisterModalProvider
  from '@components/shared/providers/LoginRegisterModalProvider/LoginRegisterModalProvider';
import AddToBoardModalProvider
  from '@components/shared/providers/AddToBoardModalProvider/AddToBoardModalProvider';
import ShareModalProvider
  from '@components/shared/providers/ShareModalProvider/ShareModalProvider';
import ExploreProductModalProvider
  from '@components/shared/providers/ExploreProductModalProvider/ExploreProductModalProvider';
import CreateProjectModalProvider
  from '@components/shared/providers/CreateProjectModalProvider/CreateProjectModalProvider';
import { withAuthenticatedUser } from '@lib/user/auth';
import { getApollo } from '@lib/apollo/apolloClient';
import DesignerBoard from '@components/pages/DesignerBoard/DesignerBoard';
import GET_DESIGNER_BOARD_QUERY from '@components/pages/DesignerBoard/get-designer-board.graphql';
import GET_DESIGNER_BOARD_RECOMMENDATIONS from '@components/pages/DesignerBoard/get-designer-board-recommendations.graphql';
import logger from '@lib/logger';
import AddedToCartConfirmationModalProvider from '@components/shared/providers/AddedToCartConfirmationModalProvider/AddedToCartConfirmationModalProvider';

const DesignBoardDetails = (props: any) => (
  <LoginRegisterModalProvider>
    <ShareModalProvider>
      <AddToBoardModalProvider>
        <CreateProjectModalProvider>
          <ExploreProductModalProvider>
            <AddedToCartConfirmationModalProvider>
              <DesignerBoard {...props} />
            </AddedToCartConfirmationModalProvider>
          </ExploreProductModalProvider>
        </CreateProjectModalProvider>
      </AddToBoardModalProvider>
    </ShareModalProvider>
  </LoginRegisterModalProvider>
);

export default DesignBoardDetails;

export const getServerSideProps = withAuthenticatedUser(async ({
  user,
}, ctx:any) => {
  const log = logger('DesignBoard');

  const { id } = ctx.query;
  const boardId = parseInt(id?.toString().split('-').shift() as string, 10);
  if (!boardId) {
    log.error({ slug: id }, `Unable to parse boardId from slug`);
    return { notFound: true };
  }

  if (id?.toString().match(/[^\d]/)) {
    return {
      redirect: {
        destination: `/interior-design-ideas/design-board/${boardId}`,
        statusCode: 301,
      },
    };
  }

  const apolloClient = getApollo();

  const [designBoardResponse, recommendationResponse] = await Promise.allSettled([
    apolloClient.query({
      query: GET_DESIGNER_BOARD_QUERY,
      variables: { id: boardId },
    }),
    apolloClient.query({
      query: GET_DESIGNER_BOARD_RECOMMENDATIONS,
      variables: { boardId },
    }),
  ]);

  if (designBoardResponse.status === 'rejected') {
    // eslint-disable-next-line no-console
    log.error({ boardId }, `Unable to load design board`, designBoardResponse.reason);
    return { notFound: true };
  }

  const designerBoard = designBoardResponse.value?.data?.board;
  if (!designerBoard) {
    return {
      notFound: true,
    };
  }

  let boardRecommendations = [];
  if (recommendationResponse.status === 'fulfilled') {
    boardRecommendations = recommendationResponse.value?.data?.designBoardRecommendations;
  } else {
    // eslint-disable-next-line no-console
    log.warn({ boardId }, `Unable to load design board recommendations for board`, recommendationResponse.reason);
  }

  return {
    props: {
      boardRecommendations,
      designerBoard,
      user
    },
  };
}, {
  requireAuth: false,
});
